<loader-pane-fragment [trace]="traceNames.viewProgramInformation"></loader-pane-fragment>
<!-- There is zero reason to have the menu bar hardcoded into this component.  Absolutely no reason at all -->
<div class="wrap920">
  <mobile-menu></mobile-menu>
  <div class="menu desktop">
    <h1>Event Information</h1>
    <div style="flex:1;"></div>
    <icon [icon]="'grow'" (click)="$event.stopPropagation(); informable.expandAll()"></icon>
    <icon [icon]="'shrink'" (click)="$event.stopPropagation(); informable.collapseAll()"></icon>
    <icon class="print" matIcon="print" (click)="uiService.print()"></icon>
  </div>
  <binary-share-toggle *ngIf="!!event"
    class="notes-top"
    [type]="'brief'"
    [shareType]="shareTypes.information"
    [shareableFormat]="'oneLine'"
    [shareCode]="event.eventId"
    [hint]="'Note: The shareable webpage is dynamic and will always load the current event information.'"
    [title]="'Event information webpage'"
    [shareTitle]="'Your shareable event information:'"
    [status]=" event.shareEventInformation ? 'On' : 'Off'"
    (toggle)="toggleShare()"
  ></binary-share-toggle>
  <enable-links *ngIf="!!event?.shareEventInformation" (toggle)="toggleEnableLinks()" [enabled]="!!event?.linksInEventInformation"></enable-links>
  <informable 
    #informable 
    [readonly]="readonly" 
    [informableType]="'event'"
    [useAssetIds]="true"
    [assetEntityHolderName]="'event information'"
  ></informable>
</div>
